import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Login() {
  const [tab, setTab] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', prenom: '', nom: '', telephone: '', rgpd_consent: false });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (tab === 'login') {
        await login(form.email, form.password);
      } else {
        if (!form.rgpd_consent) { setError('Veuillez accepter les conditions'); setLoading(false); return; }
        await register(form);
      }
      navigate('/order');
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });
  const inputClass = "w-full bg-white border border-[#E2D1B8] rounded-xl px-4 py-3 text-[#332A1C] placeholder-[#C9B494] focus:outline-none focus:border-[#C4673D] focus:ring-2 focus:ring-[#C4673D]/20 transition";

  return (
    <div className="min-h-screen bg-[#FEFCF8] flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="font-serif text-3xl text-[#332A1C]">Les Halles</Link>
          <p className="text-[#8B7355] mt-1">de la Cartoucherie</p>
        </div>

        {/* Tabs */}
        <div className="flex mb-6 bg-white rounded-xl border border-[#E2D1B8] p-1">
          <button onClick={() => setTab('login')}
            className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition ${tab === 'login' ? 'bg-[#C4673D] text-white' : 'text-[#8B7355]'}`}>
            Connexion
          </button>
          <button onClick={() => setTab('register')}
            className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition ${tab === 'register' ? 'bg-[#C4673D] text-white' : 'text-[#8B7355]'}`}>
            Inscription
          </button>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl border border-[#F3DFC0] shadow-sm p-6 space-y-4">
          {tab === 'register' && (
            <div className="grid grid-cols-2 gap-3">
              <input type="text" placeholder="Prénom" value={form.prenom} onChange={set('prenom')} className={inputClass} />
              <input type="text" placeholder="Nom" value={form.nom} onChange={set('nom')} className={inputClass} />
            </div>
          )}

          <input type="email" placeholder="Email" value={form.email} onChange={set('email')} required className={inputClass} />
          <input type="password" placeholder="Mot de passe" value={form.password} onChange={set('password')} required className={inputClass} />

          {tab === 'register' && (
            <>
              <input type="tel" placeholder="Téléphone" value={form.telephone} onChange={set('telephone')} required className={inputClass} />
              <label className="flex items-start gap-3 cursor-pointer">
                <input type="checkbox" checked={form.rgpd_consent} onChange={set('rgpd_consent')} className="mt-1 accent-[#C4673D]" />
                <span className="text-xs text-[#8B7355]">J'accepte la politique de confidentialité des Halles de la Cartoucherie</span>
              </label>
            </>
          )}

          {error && <p className="text-red-600 text-sm bg-red-50 p-3 rounded-xl">{error}</p>}

          <button type="submit" disabled={loading}
            className="w-full bg-[#C4673D] text-white py-3.5 rounded-xl font-semibold hover:bg-[#A8532E] transition disabled:opacity-50">
            {loading ? 'Chargement...' : tab === 'login' ? 'Se connecter' : "S'inscrire"}
          </button>
        </form>

        <div className="text-center mt-6">
          <Link to="/order" className="text-[#8B7355] text-sm hover:text-[#C4673D] transition">
            Continuer sans compte →
          </Link>
        </div>

        <div className="text-center mt-4 pt-4 border-t border-[#F3DFC0]">
          <Link to="/stand-login" className="text-[#C9B494] text-xs hover:text-[#8B7355] transition">
            Accès gérant de stand
          </Link>
        </div>
      </div>
    </div>
  );
}
